import {
    Injectable,
    Signal
} from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import {
    DatiqUserTiers,
    IDatiqUser,
    IDatiqUserModalInfo,
    IDatiqUserStateService,
} from '../models';
import { DatiqUserStoreService } from '../store';

@Injectable({
    providedIn: 'root',
})
export class DatiqUserStateService implements IDatiqUserStateService {
    constructor(private _store?: DatiqUserStoreService) {}

    logOut() {
        this._store.logOut();
    }

    getUiCache$(id: string): Observable<unknown> {
        return this._store.getUiCache$(id);
    }

    loginSuccess(user: IDatiqUser): void {
        this._store.logInUserSuccess(user);
    }

    isLoggedInUserLoaded$(): Observable<boolean> {
        return this._store.isLoggedInUserLoaded$();
    }

    isLoggedInUserLoggedIn$(): Observable<boolean> {
        return this._store.isLoggedInUserLoggedIn$();
    }

    isLoggedInUserLoggedIn(): Signal<boolean> {
        return this._store.isLoggedInUserLoggedInSig();
    }

    getLoggedInUser$(): Observable<IDatiqUser> {
        return this._store.getLoggedInUser$();
    }

    hasPermissions$(permissionsList: string[]): Observable<boolean> {
        return this._store.hasPermissions$(permissionsList);
    }

    hasCapabilities$(capabilities: string[]): Observable<boolean> {
        return this._store.hasCapabilities$(capabilities);
    }

    hasCapabilities(capabilities: string[]): Signal<boolean> {
        return this._store.hasCapabilities(capabilities);
    }

    isLoggedInUserTier$(tier: DatiqUserTiers): Observable<boolean> {
        return this._store.isLoggedInUserTier$(tier);
    }

    getUserLoggedInTier$(): Observable<DatiqUserTiers> {
        return this._store.getUserLoggedInTier$().pipe(distinctUntilChanged());
    }

    setModalShowAgain(modalId: string, state: boolean): void {
        return this._store.setModalShowAgain(modalId, state);
    }

    getModalState$(modalId: string): Observable<IDatiqUserModalInfo> {
        return this._store.getModalState$(modalId);
    }

    viewModal(modalId: string) {
        this._store.viewModal(modalId);
    }

    cacheUI(uiId: string, uiSettings: unknown): void {
        this._store.cacheUI(uiId, uiSettings);
    }

    refreshUserResources(): void {
        this._store.refreshUserResources();
    }
}
